import { createStructuredSelector } from 'reselect';
import { selectionState, isResizingRow, areActionsDisabled } from 'containers/App/selectors';
import {
  callToActions,
  images,
  reusableLayouts,
  textComponents,
} from 'containers/Documents/selectors';
import { isOpenToolbar } from 'containers/Project/selectors';

export const artboardCellSelector = createStructuredSelector({
  images,
  callToActions,
  reusableLayouts,
  textComponents,
  isOpenToolbar,
  selectionState,
  isResizingRow,
  areActionsDisabled,
});
